export default {
	'main-info': 'Información principal',
	archive: 'archivo',
	unarchive: 'desanimado',
	'change-archive-status': 'Cambiar el estado del archivo',
	'change-archive-status-alert': '¿Comparte que quieres cambiar el estado de archivo de la cuenta?',
}